<ion-toolbar class="safe-padding-top" [ngClass]="ngClass">
  <img class="logo" src="assets/imgs/exeevo.svg" alt="Exeevo">
  <ion-buttons slot="end">
    <!-- Renders while anything is pinned OR waiting in the overflow: a rep who unpins
         everything still needs the "..." to pin something back. -->
    <div class="quick-create" *ngIf="hasBaselineEnabled && !isInCustomerTool && (visibleTypes.length || overflowTypes.length)">
      <ion-button *ngFor="let type of visibleTypes" [disabled]="createInFlight" (click)="runType(type, $event)"
        [attr.data-testid]="'topbar-quick-action-' + type.labelKey.toLowerCase().split('_').join('-')"
        class="new-activity-button" [class.quick-create-disabled]="!!type.disabledReason?.()"
        [attr.aria-disabled]="!!type.disabledReason?.()"
        [tooltip]="type.labelKey | translate: type.labelParams?.()" [display]="showTooltips" (events)="onTooltipVisibilityChange()"
        [attr.aria-label]="type.labelKey | translate: type.labelParams?.()">
        <ion-icon slot="icon-only" src="assets/imgs/{{type.icon}}"></ion-icon>
      </ion-button>
      <ng-container *ngIf="overflowTypes.length">
        <ion-button (click)="openOverflow($event)" class="new-activity-button quick-create-more" data-testid="topbar-quick-action-more"
          [tooltip]="'MORE_ACTIVITY_TYPES' | translate" [display]="showTooltips" (events)="onTooltipVisibilityChange()"
          [attr.aria-label]="'MORE' | translate">
          <ion-icon slot="icon-only" src="assets/imgs/more-vertical.svg"></ion-icon>
        </ion-button>
      </ng-container>
    </div>
    <ion-button *ngIf="hasBaselineEnabled" (click)="openNotifications()">
      <ion-icon slot="icon-only"
        src="assets/imgs/notification_whitedot.svg" class="tab-notification-dot"
        *ngIf="hasAnyUnReadNotifications"></ion-icon>
      <ion-icon src='assets/imgs/notification.svg' slot="icon-only"></ion-icon>
    </ion-button>
    <ion-button class="user" [ngClass]="{active: isProfilePopupOpen, 'has-photo': !!userPhoto}" (click)="openProfile($event)">
      <img *ngIf="userPhoto; else userInitials" class="user-photo" [src]="userPhoto" [alt]="authService.user?.displayName">
      <ng-template #userInitials><p class="user">{{getInitials()}}</p></ng-template>
    </ion-button>
  </ion-buttons>
</ion-toolbar>
<div class="sync-banner" *ngIf="!backgroundUploadInProgress && !syncInProgress && authService.showSyncBanner">
  <div class="banner-text" *ngIf="!device.isOffline">
    {{ 'SYNC_BANNER_ONLINE_MESSAGE' | translate }}
  </div>

  <div class="banner-text banner-text-offline" *ngIf="device.isOffline">
    {{ 'SYNC_BANNER_OFFLINE_MESSAGE' | translate }}
  </div>
 
  <ion-button size="small" fill="outline" (click)="syncData()" *ngIf="!device.isOffline">
    {{ 'GENEE_SYNC_NOW' | translate }}
    <ion-icon slot="end" src="assets/imgs/refreshIcon.svg"></ion-icon>
  </ion-button>
</div>

<ng-container *ngIf="backgroundUploadInProgress || syncInProgress || localDbDataLoadInProgress">
  <ion-progress-bar mode="ios" class="left-progress-bar" type="indeterminate"></ion-progress-bar>
  <div class="in-progress">
    <ion-spinner></ion-spinner>
    <span class="secondary-text">{{ syncMessage }}</span>
  </div>
</ng-container>